function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const closeSelector = (e) => e.removeAttribute("open");

(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "localization-selector",
    class extends e.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          trigger: "[data-trigger]",
          form: "form",
        });
      }

      render() {
        this.$trigger.addEventListener(
          "click",
          this._handleTriggerClick.bind(this)
        ),
          this.addEventListener("change", this._handleInputChange.bind(this));
      }

      _handleTriggerClick(e) {
        e.stopPropagation(),
          this.toggleAttribute("open"),
          document
            .querySelectorAll(this.tagName)
            .forEach(this._closeForeignSelector.bind(this));
      }

      _handleInputChange(e) {
        this.$form.submit();
      }

      _closeForeignSelector(e) {
        e !== this && closeSelector(e);
      }
    }
  );
})(),
  document.addEventListener("click", (e) => {
    document.querySelectorAll("localization-selector").forEach(closeSelector);
  });
